import { api } from './api';
import type { Vault, CreateVaultRequest, UpdateVaultRequest } from '@/types/vault';

export const vaultService = {
  getAll: (includeShared = false) =>
    api.get<Vault[]>(`/vaults${includeShared ? '?includeShared=true' : ''}`),

  getOne: (id: string, allowShared = false) =>
    api.get<Vault>(`/vaults/${id}${allowShared ? '?allowShared=true' : ''}`),

  create: (data: CreateVaultRequest) => api.post<Vault>('/vaults', data),

  update: (id: string, data: UpdateVaultRequest) =>
    api.patch<Vault>(`/vaults/${id}`, data),

  delete: (id: string) => api.delete(`/vaults/${id}`),
};
